<template>
  <div class="inHospitalDialog" @contextmenu.prevent="">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogStatus"
      width="1205px"
      class="dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
    > 
      <div class="navBorder"></div>
      <div class="main">
        <div class="left">
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">ID**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.id_in_hospital"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">姓名**</p>
              <el-input
                class="popInput"
                v-model="toDialoPatientsData.name"
                :disabled="true"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">住院号**
                <!-- <el-popover
                  placement="top-start"
                  title="帮助"
                  width="240"
                  trigger="hover"
                  content="基于相同的住院号可前后患者的同一次住院"
                >
                  <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
                </el-popover> -->
              </p>
              <el-input
                class="popInput"
                v-model="inHospitalData.medical_record_num"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">病程**</p>
              <el-autocomplete
                class="popInput"
                v-model="inHospitalData.disease_course"
                :fetch-suggestions="diseaseCourseSuggesion"
                placeholder="请选择或手动输入病程"
                @blur="saveSuggesion(3)"
              ></el-autocomplete>
            </div>
          </el-col>          

          <!-- <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">是否病危</p>
              <el-button-group class="popInput isBW">
                <el-button
                  class="isBWItem"
                  @click.native="choiceBW(0)"
                  :class="{'activeBW':BWIndex ==1}"
                  type="primary"
                >是</el-button>
                <el-button
                  class="isBWItem"
                  @click.native="choiceBW(1)"
                  :class="{'activeBW':BWIndex ==0}"
                  type="primary"
                >否</el-button>
              </el-button-group>
            </div>
          </el-col> -->

          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">入院日期</p>
              <el-date-picker
                prefix-icon="iconfont icon-rili"
                v-model="inHospitalData.inpat_date"
                class="popInput"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">出院日期</p>
              <el-date-picker
                prefix-icon="iconfont icon-rili"
                class="popInput"
                type="date"
                v-model="inHospitalData.outpat_date"
                placeholder="选择日期"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">住院天数</p>
              <el-input
                class="popInput"
                type="number"
                v-model="inHospitalData.inpat_days_num"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">诊断</p>
              <!--<el-input
                class="popInput"
                type="text"
                v-model="inHospitalData.diagnosis"
                placeholder="请输入内容"
              ></el-input>-->
              <el-autocomplete
                class="popInput"
                v-model="inHospitalData.diagnosis"
                :fetch-suggestions="queryDisease"
                placeholder="选择诊断结果"
                :trigger-on-focus="false"
                @select="selectedDisease"
                @blur="selectedDiseaseBlur(inHospitalData.diagnosis)"
                size="small"
              ></el-autocomplete>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">疗效</p>
              <el-select
                placeholder="请选择"
                v-model="inHospitalData.curative_effect"
                class="popInput"
              >
                <el-option
                  v-for="item in curativeEffectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col> -->
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">中/西医治疗</p>
              <el-select placeholder="请选择" v-model="inHospitalData.treat_method" class="popInput">
                <el-option
                  v-for="item in treatMethodOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">主诊医师</p>
              <el-autocomplete
                class="popInput"
                v-model="inHospitalData.main_diagnosis_doctor"
                :fetch-suggestions="mainSuggesion"
                placeholder="请输入内容"
                @blur="saveSuggesion(0)"
              ></el-autocomplete>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">副主诊医师</p>
              <el-autocomplete
                class="popInput"
                v-model="inHospitalData.vice_diagnosis_doctor"
                :fetch-suggestions="viceSuggesion"
                placeholder="请输入内容"
                @blur="saveSuggesion(1)"
              ></el-autocomplete>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">住院医师</p>
              <el-autocomplete
                class="popInput"
                v-model="inHospitalData.inpat_doctor"
                :fetch-suggestions="inpatSuggesion"
                placeholder="请输入内容"
                placement="top"
                @blur="saveSuggesion(2)"
              ></el-autocomplete>
            </div>
          </el-col>

          <el-col :span="24">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">病情描述</p>
              <el-input
                class="popInput popInputSingle"
                v-model="inHospitalData.curative_effect"
                type="textarea"
                :maxlength="textAreaMaxLen"
                placeholder="请输入病情及治疗进展,长度不超过70个字"
              ></el-input>
            </div>
          </el-col>

          <el-col :span="24">
            <div class="leftItem">
              <p class="rightItemTitle popTitleDialog">备注
                <el-popover
                  placement="top-start"
                  title="帮助"
                  width="200"
                  trigger="hover"
                  content="此处输入的备注信息，可以在【高级搜索】-【住院】-【就诊记录】中进行检索"
                >
                  <i slot="reference" class="iconfont icon-bangzhu popTips" ></i>
                </el-popover>
              </p>
              <el-input
                class="popInput popInputSingle"
                v-model="inHospitalData.remarks"
                type="textarea"
                :maxlength="textAreaMaxLen"
                placeholder="请输入备注内容,长度不超过70个字"
              ></el-input>
            </div>
          </el-col>

          <el-col :span="12" :offset="12">
            <button
              class="btn iconfont leftItemSubmit"
              @click="submitInHospital"
              style="padding: 0"
            >{{submitText}}</button>
          </el-col>
        </div>
        <div class="right">
          <div class="rightItem">
            <p class="rightItemTitle popTitleDialog">临床图片</p>
            <div class="rightItemContent"
              @click.stop="choiceInpatImg"
              v-loading="inpatLoading"
              element-loading-text="正在上传"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.4)"
            >
              <div class="images-wrap" v-if="inpatImagesList.length" @click.stop="">
                <div class="images-list">
                  <div
                    class="image-item"
                    :style="`background-image: url(${hospitalization_imagesThumbnails + item.path})`"
                    v-for="(item, index) in inpatImagesList"
                    :key="index"
                    @click="showPic(item.path)"
                    @mouseenter="showOption($event, item)"
                    @mouseleave="item.deletePic = false"
                  >
                    <div class="icon-wrapper" v-show="item.deletePic">
                      <div class="menu-btn" @click.stop="deleteImg(item, index, 1)">
                        <img class="delete-icon" src="../assets/delete.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-btn" @click="choiceInpatImg">添加图片(最多{{maxImageNum}}张)</div>
              </div>
              <input
                ref="inpatInput"
                class="inpatInput"
                type="file"
                placeholder
                @change.stop="changeInpat"
                accept="image/*"
                multiple="multiple"
                @click.stop=""
              />
              <i class="iconfont icon-jia rightItemIcon"></i>
            </div>
          </div>
          <div class="rightItem" v-if="outpatImagesList.length">
            <p class="rightItemTitle popTitleDialog">出院照片</p>
            <div class="rightItemContent"
              v-loading="outpatLoading"
              element-loading-text="正在上传"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.4)"
              @click="choiceOutpatImg"
            >
              <div class="images-wrap" v-if="outpatImagesList.length" @click.stop="">
                <div class="images-list">
                  <div
                    class="image-item"
                    :style="`background-image: url(${hospitalization_imagesThumbnails + item.path})`"
                    v-for="(item, index) in outpatImagesList"
                    :key="index"
                    @click="showPic(item.path)"
                    @mouseenter="showOption($event, item)"
                    @mouseleave="item.deletePic = false"
                  >
                    <div class="icon-wrapper" v-show="item.deletePic">
                      <div class="menu-btn" @click.stop="deleteImg(item, index, 2)">
                        <img class="delete-icon" src="../assets/delete.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-btn" @click="choiceOutpatImg">添加图片</div>
              </div>
              <input
                ref="outpatInput"
                class="outpatInput"
                type="file"
                placeholder
                @change.stop="changeOutpat"
                accept="image/*"
                multiple="multiple"
                @click.stop=""
              />
              <i class="iconfont icon-jia rightItemIcon"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-pic"
      :visible.sync="showLargeImage1"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      modal
      top="0"
      :fullscreen="true"
      @close="closePic"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImage"></Lookimage>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import api from "../api";
import addHospitalizationInfo from "../gql/addHospitalizationInfo.gql";
import getInHospitalById from "../gql/getInHospitalById.gql";
import setHospitalzationInfo from "../gql/setHospitalzationInfo.gql";
import Jimp from 'jimp';
import gql from 'graphql-tag';
import axios from 'axios';
import Lookimage from './LookBigImage.vue';
let template = {};
export default {
  name: 'inHospitalDialog',
  data() {
    return {
      // 缩略图地址
      hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
      // 大图地址
      hospitalization_images: api.hospitalization_images,
      knowledgeDic: {},
      formLabelAlign: {},
      id: "146545643443",
      BWIndex: 1,
      inHospitalData: {
        patient_id: "",
        is_critical: "",
        medical_record_num: "",
        inpat_date: "",
        outpat_date: "",
        inpat_days_num: "",
        diagnosis: "",
        curative_effect: "",
        treat_method: "",
        main_diagnosis_doctor: "",
        vice_diagnosis_doctor: "",
        inpat_doctor: "",
        inpat_img: "",
        outpat_img: "",
        created_time: "",
        // 2025-01-03 新增，数据库已有
        disease_course: "", //病程
        remarks: "", //备注
        update_time: "",

      },
      diagnosisId: '',
      curativeEffectOptions: [
        { label: "痊愈", id: 0, value: "痊愈" },
        { label: "好转", id: 1, value: "好转" },
        { label: "无效", id: 2, value: "无效" }
      ],
      treatMethodOptions: [
        { label: "中西医治疗", id: 0, value: "中西医治疗" },
        { label: "中医治疗", id: 1, value: "中医治疗" },
        { label: "西医治疗", id: 2, value: "西医治疗" }
      ],
      // 2025-01-03 added by steven.
      diseaseCourseOptions: [
        {value:"入院"}, 
        {value:"出院"}, 
        {value:"日常"}
      ],
      mainDoctorList: [],
      viceDoctorList: [],
      inpatDoctorList: [],
      diseaseCourseList: [],

      inpatImgPath: "",
      outpatImgPath: "",
      imgHeader: api.doctor_header,
      submitText: "保存住院信息后添加图片",
      allDisease: [],
      // 全部图片列表
      allImagesList: [],
      // 入院图片列表
      inpatImagesList: [],
      // 出院图片列表
      outpatImagesList: [],
      // 入院上传图片loading
      inpatLoading: false,
      // 出院上传图片loading
      outpatLoading: false,
      addHospitalId: -1,
      // 是否刷新列表
      isRefreshHandler: false,
      // 历史诊断详情页是否刷新图片
      isRefreshHandler1: false,
      showLargeImage1: false,
      // 住院查看大图地址
      largeImage: '',
      // 诊断算则和blur触发控制开关
      isTrigger: false,
      // 将病程等信息动态添加到对话框Title
      // dialogTitle: "住院记录",
      textAreaMaxLen: 70,
      // 最大图片数量
      maxImageNum: 6,
    };
  },
  components: {
    Lookimage,
  },
  computed: {
    dialogStatus: {
      get() {
        if (this.isShowInHospital) {
          this.mainDoctorList = [];
          this.viceDoctorList = [];
          this.inpatDoctorList = [];
          this.diseaseCourseList = [];
          this.getLocalList(this.mainDoctorList, "mainDoctorListtest");
          this.getLocalList(this.viceDoctorList, "viceDoctorListtest");
          this.getLocalList(this.inpatDoctorList, "inpatDoctorListtest");
          this.getLocalList(this.diseaseCourseList, "diseaseCourseListtest");
          this.resetData();
        }

        return this.isShowInHospital;
      },
      set(val) {
        this.$emit("setInHpspitalStatus", val);
      }
    },
    dialogTitle(){
      let dialogTitle = "住院记录";
      if(this.inHospitalData.disease_course){
        dialogTitle = dialogTitle + "--" + this.inHospitalData.disease_course;

      }
      if(this.inHospitalData.update_time){
        dialogTitle = dialogTitle + "--" + this.inHospitalData.update_time;

      }
      return dialogTitle

    }
  },
  watch: {
    async 'lastDiagnosisText'(val) {
      try {
        const res = await this.$apollo.query({
          query: gql`{
          patient(id: ${val.id}){
              id
              last_diagnosis_text
            }
          }`,
          fetchPolicy: "no-cache",
        });
        const doctorConclusion = res.data.patient.last_diagnosis_text;
        // 查到最后一次的诊断结果
        if (doctorConclusion) {
          this.diagnosisId = doctorConclusion;
          this.inHospitalData.diagnosis = this.formatConclusion(doctorConclusion);
        }
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    async 'openHospitalId'(newVal) {
      if (newVal) {
        this.submitText = "修改";
        await this.getInhospital(Number(newVal));
        this.addHospitalId = Number(newVal);
      } else {
        this.resetData();
        this.submitText = "保存住院信息后添加图片";
      }
    },
    "inHospitalData.inpat_date"(newVal) {
      if (newVal) {
        this.$set(
          this.inHospitalData,
          "inpat_date",
          moment(newVal).format("YYYY-MM-DD")
        );
      }
    },
    "inHospitalData.outpat_date"(newVal) {
      if (newVal) {
        if (this.inHospitalData.inpat_date) {
          let contrast = !moment(newVal).isBefore(
            this.inHospitalData.inpat_date
          );
          if (contrast) {
            let days = moment(newVal).diff(
              moment(this.inHospitalData.inpat_date),
              "days"
            );
            this.$set(this.inHospitalData, "inpat_days_num", Number(days) + 1);
          } else {
            this.$alert("出院日期不能小于住院日期", "提示", {
              confirmButtonText: "确定"
            });
            this.$set(this.inHospitalData, "inpat_days_num", "");
            this.$set(this.inHospitalData, "outpat_date", "");
          }
        }
      } else {
        this.$set(this.inHospitalData, "inpat_days_num", "");
      }
    },
    "inHospitalData.inpat_days_num"(newVal) {
      if (newVal) {
        if (newVal <= 0) {
          this.$set(this.inHospitalData, "inpat_days_num", "");
        } else {
          if (this.inHospitalData.inpat_date) {
            let aa = moment(this.inHospitalData.inpat_date)
              .add(Number(newVal) - 1, "days")
              .format("YYYY-MM-DD");
            this.$set(this.inHospitalData, "outpat_date", aa);
          }
        }
      } else {
        this.$set(this.inHospitalData, "outpat_date", "");
      }
    }
  },
  props: {
    isShowInHospital: {
      type: Boolean,
      default: () => false
    },
    toDialoPatientsData: {
      type: Object
    },
    openHospitalId: {
      type: Number,
      default: () => null
    },
    lastDiagnosisText: Object,
  },
  methods: {
    // 删除出入院图片
    async deleteImg(item, index, type) {
      this.$confirm('确定要删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation(
          $hospitalization_id: Int!
          $id: Int!
        ){
          removeHospitalizationImages(
            hospitalization_id: $hospitalization_id
            id: $id
          )
        }`,
            variables: {
              id: item.id,
              hospitalization_id: this.addHospitalId,
            },
          });
          if (type === 1) {
            this.inpatImagesList.splice(index, 1);
          } else if (type === 2) {
            this.outpatImagesList.splice(index, 1);
          }
          this.isRefreshHandler = true;
          this.isRefreshHandler1 = true;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      }).catch(() => {
        // console.log('取消')
      });
    },
    // 显示删除图片操作
    showOption(event, item) {
      item.deletePic = true;
    },
    closePic() {
      this.largeImage = '';
    },
    showPic(path) {
      this.largeImage = `${this.hospitalization_images}${path}`;
      this.showLargeImage1 = true;
    },
    async dealBmpImage(filePath) {
      const image = await Jimp.read(filePath);
      // image.quality(95);
      const base64 = await image.getBase64Async(Jimp.MIME_JPEG);
      return base64;
    },
    closeDialog() {
      if (this.isRefreshHandler) {
        this.$emit('refreshHandler',Number(this.toDialoPatientsData.id));
      }
      if (this.isRefreshHandler1) {
        this.$emit('refreshHandler2', {
          id: this.addHospitalId,
          images: this.allImagesList,
        });
      }
      this.diagnosisId = '';
      this.addHospitalId = -1;
      this.inpatImagesList = [];
      this.outpatImagesList = [];
      this.allImagesList = [];
      this.isRefreshHandler = false;
      this.isRefreshHandler1 = false;
    },
    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.knowledgeDic[id]) {
          name = this.knowledgeDic[id].name;
        }
      }
      return name ? name : id;
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`{
          me{
            id
            template
          }
        }`,
        fetchPolicy: 'no-cache',
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === '') {
        return;
      }
      const msg =  await axios.request({
        method: 'get',
        url: api.template + path,
      });
      template = msg.data;
    },
    async getKnowledgeDic() {
      // 获取报告模板病名与id文件
      try {
        const knowledgeDic = await axios.request({
          method: "get",
          url: api.knowledgeDic
        });
        this.knowledgeDic = knowledgeDic.data;
        // 生成影像诊断筛选数据
        const allDiseaseArr = [];
        for (let key in this.knowledgeDic) {
          if (this.knowledgeDic.hasOwnProperty(key)) {
            allDiseaseArr.push({
              value: this.knowledgeDic[key].name,
              id: key
            });
          }
        }
        this.allDisease = allDiseaseArr;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    queryDisease(queryString, cb) {
      const restaurants = this.allDisease;
      const results = queryString ? restaurants.filter(this.filterDisease(queryString)) : restaurants;
      const arr = [];
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
            if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
              arr.push({
                id: data[i].id,
                value: data[i].name,
              })
            }
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      for (const item of results) {
        const findIndex = arr.findIndex(item1 => item.value === item1.value);
        if (findIndex === -1) {
          arr.push(item);
        }
      }
      cb(arr);
    },
    filterDisease(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    selectedDisease(item) {
      this.isTrigger = true;
      // this.selectedDiagnose = true;
      // this.inHospitalData.diagnosis = item.value;
      this.diagnosisId = item.id;
    },
    selectedDiseaseBlur(val) {
      setTimeout(() => {
        if (this.isTrigger) {
          this.isTrigger = false;
          return;
        }
        if (!val) {
          this.diagnosisId = '';
        } else {
          const findId = this.queryTemplatesByName(val);
          if (findId) {
            this.diagnosisId = findId;
          } else {
            this.diagnosisId = '';
          }
        }
      }, 300);
    },
    // 通过name查找影像诊断id
    queryTemplatesByName(name) {
      let id;
      // 在自定义模板中查找
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === name) {
            id = data[i].id;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义模板中为找到就在原始模板中找
      for (const item of this.allDisease) {
        if (item.value === name) {
          id = item.id;
          break;
        }
      }
      return id;
    },
    resetData() {
      this.BWIndex = 1;
      this.inHospitalData.medical_record_num = this.toDialoPatientsData.medical_record_num ?
      this.toDialoPatientsData.medical_record_num : '';
      this.inHospitalData.inpat_days_num = -1;
      this.inHospitalData.diagnosis = "";
      this.inHospitalData.curative_effect = "";
      this.inHospitalData.treat_method = "";
      this.inHospitalData.inpat_doctor = "";
      this.inHospitalData.main_diagnosis_doctor = "";
      this.inHospitalData.vice_diagnosis_doctor = "";
      this.inHospitalData.inpat_date = "";
      this.inHospitalData.outpat_date = "";
      this.inHospitalData.disease_course = "",
      this.inHospitalData.remarks = ""
    },
    async getInhospital(id) {
      try {
        let res = await this.$apollo.query({
          query: getInHospitalById,
          fetchPolicy: "no-cache",
          variables: {
            id
          }
        });
        let data = res.data.hospitalization;
        // console.log("hospitalData.disease_course:", res.data.hospitalization.disease_course);
        this.BWIndex = data.is_critical;
        this.inHospitalData.medical_record_num = data.medical_record_num;
        this.inHospitalData.inpat_days_num = data.inpat_days_num;
        this.diagnosisId = data.diagnosis;
        this.inHospitalData.diagnosis = this.formatConclusion(data.diagnosis);
        this.inHospitalData.curative_effect = data.curative_effect;
        this.inHospitalData.treat_method = data.treat_method;
        this.inHospitalData.inpat_doctor = data.inpat_doctor;
        this.inHospitalData.main_diagnosis_doctor = data.main_diagnosis_doctor;
        this.inHospitalData.vice_diagnosis_doctor = data.vice_diagnosis_doctor;
        this.inHospitalData.disease_course = data.disease_course;
        this.inHospitalData.remarks = data.remarks;
        if(data.update_time){
          this.inHospitalData.update_time = moment(data.update_time).format(
            "YYYY-MM-DD"
          );
        }else{
          this.inHospitalData.update_time = "";
        }


        // 显示图片数据
        for (const item of data.image_hospitalization) {
          item.deletePic = false;
          item.menuLeft = '';
          item.menuTop = '';
        }
        this.inpatImagesList = data.image_hospitalization.filter(item => item.type === 1);
        this.outpatImagesList = data.image_hospitalization.filter(item => item.type === 2);
        this.allImagesList = data.image_hospitalization;
        if (data.inpat_date !== -30610253143000) {
          this.inHospitalData.inpat_date = moment(data.inpat_date).format(
            "YYYY-MM-DD"
          );
        } else {
          this.inHospitalData.inpat_date = "";
        }
        if (data.outpat_date !== -30610253143000) {
          this.inHospitalData.outpat_date = moment(data.outpat_date).format(
            "YYYY-MM-DD"
          );
        } else {
          this.inHospitalData.outpat_date = "";
        }
      } catch (error) {
        // console.log(error);
        this.$message.success("数据获取失败");
        this.$emit("setInHpspitalStatus", false);
      }
    },
    getLocalList(thisData, localName) {
      let DoctorList = localStorage.getItem(localName);
      if (DoctorList) {
        let data = JSON.parse(DoctorList);
        for (const item of data) {
          thisData.push({ value: item });
        }
      }
    },
    choiceBW(status) {
      this.BWIndex = status;
    },
    // 病程列表，预置 this.diseaseCourseList
    diseaseCourseSuggesion(suggesionString, cb) {
      // let results = this.diseaseCourseList;
      // 将默认的选项放到列表最前面
      let results = this.diseaseCourseOptions.concat(this.diseaseCourseList);
      // console.log("diseaseCourseSuggesion:",results);
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    mainSuggesion(mainSuggesionString, cb) {
      let results = this.mainDoctorList;
      // 调用 callback 返回建议列表的数据
      console.log("mainSuggesion:",results);
      cb(results);
    },
    viceSuggesion(viceSuggesionString, cb) {
      let results = this.viceDoctorList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    inpatSuggesion(inpatSuggesionString, cb) {
      let results = this.inpatDoctorList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    saveSuggesion(type) {
      if (type === 0) {
        this.saveLocalList(
          this.inHospitalData.main_diagnosis_doctor,
          "mainDoctorListtest"
        );
      } else if (type === 1) {
        this.saveLocalList(
          this.inHospitalData.vice_diagnosis_doctor,
          "viceDoctorListtest"
        );
      } else if (type === 2) {
        this.saveLocalList(
          this.inHospitalData.inpat_doctor,
          "inpatDoctorListtest"
        );
      }else if (type === 3) {
        let found = false;
        // 是否已经存在于预设选项
        for(let option of this.diseaseCourseOptions){
          if(this.inHospitalData.disease_course===option.value){
            found = true;
            break;
          }
        }
        if(!found){
          this.saveLocalList(
            this.inHospitalData.disease_course,
            "diseaseCourseListtest"
          );
        }
      } else {

      }
    },
    saveLocalList(thisData, localName) {
      if (thisData) {
        let mainDoctorList = localStorage.getItem(localName);
        if (mainDoctorList) {
          let data = JSON.parse(mainDoctorList);
          data.unshift(thisData);
          let NewData = _.chunk(_.uniq(data), 5)[0];
          localStorage.setItem(localName, JSON.stringify(NewData));
          // console.log("saveLocalList:",data);
        } else {
          let data = [];
          data.unshift(thisData);
          localStorage.setItem(localName, JSON.stringify(data));
          // console.log("saveLocalList:",data);
        }
        
      }
    },
    async submitInHospital() {
      if (this.openHospitalId) {
        await this.setInHospital();
      } else {
        await this.addInHospital();
      }
    },
    async addInHospital() {
      if (this.addHospitalId > -1) {
        this.$message.error("已经新增了住院信息");
        return
      }
      try {
        const res = await this.$apollo.mutate({
          mutation: addHospitalizationInfo,
          variables: {
            patient_id: Number(this.toDialoPatientsData.id),
            is_critical: this.BWIndex,
            medical_record_num: this.inHospitalData.medical_record_num,
            inpat_date: this.inHospitalData.inpat_date
              ? this.inHospitalData.inpat_date
              : "1000-01-01 00:00:00",
            outpat_date: this.inHospitalData.outpat_date
              ? this.inHospitalData.outpat_date
              : "1000-01-01 00:00:00",
            inpat_days_num: this.inHospitalData.inpat_days_num
              ? this.inHospitalData.inpat_days_num
              : -1,
            diagnosis: this.inHospitalData.diagnosis,
            curative_effect: this.inHospitalData.curative_effect,
            treat_method: this.inHospitalData.treat_method,
            main_diagnosis_doctor: this.inHospitalData.main_diagnosis_doctor,
            vice_diagnosis_doctor: this.inHospitalData.vice_diagnosis_doctor,
            inpat_doctor: this.inHospitalData.inpat_doctor,
            inpat_img: this.inHospitalData.inpat_img,
            outpat_img: this.inHospitalData.outpat_img,
            disease_course: this.inHospitalData.disease_course,
            remarks: this.inHospitalData.remarks
          }
        });
        this.addHospitalId = res.data.addHospitalizationInfo.id;
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
        // this.$emit('setInHpspitalStatus',false);
      } catch (error) {
        this.$message.error("保存失败");
      }
    },
    async setInHospital() {
      try {
        await this.$apollo.mutate({
          mutation: setHospitalzationInfo,
          variables: {
            id: this.openHospitalId,
            patient_id: Number(this.toDialoPatientsData.id),
            is_critical: this.BWIndex,
            medical_record_num: this.inHospitalData.medical_record_num,
            inpat_date: this.inHospitalData.inpat_date
              ? this.inHospitalData.inpat_date
              : "1000-01-01 00:00:00",
            outpat_date: this.inHospitalData.outpat_date
              ? this.inHospitalData.outpat_date
              : "1000-01-01 00:00:00",
            inpat_days_num: this.inHospitalData.inpat_days_num
              ? this.inHospitalData.inpat_days_num
              : -1,
            diagnosis: this.inHospitalData.diagnosis,
            curative_effect: this.inHospitalData.curative_effect,
            treat_method: this.inHospitalData.treat_method,
            main_diagnosis_doctor: this.inHospitalData.main_diagnosis_doctor,
            vice_diagnosis_doctor: this.inHospitalData.vice_diagnosis_doctor,
            inpat_doctor: this.inHospitalData.inpat_doctor,
            disease_course: this.inHospitalData.disease_course,
            remarks: this.inHospitalData.remarks
          }
        });
        this.$message.success("数据已保存");
        this.isRefreshHandler = true;
        this.$emit('refreshHandler1', {
          id: this.openHospitalId,
          medical_record_num: this.inHospitalData.medical_record_num,
          inpat_date: this.inHospitalData.inpat_date,
          outpat_date: this.inHospitalData.outpat_date,
          diagnosis: this.diagnosisId ? this.diagnosisId : this.inHospitalData.diagnosis,
          curative_effect: this.inHospitalData.curative_effect,
          // images: this.allImagesList,
        });
        this.$emit('setInHpspitalStatus',false);
      } catch (error) {
        this.$message.error("保存失败");
      }
    },
    choiceInpatImg() {
      if (this.addHospitalId === -1) {
        this.$message.error('请先新增住院信息');
        return;
      }
      this.$refs.inpatInput.click();
    },
    choiceOutpatImg() {
      if (this.addHospitalId === -1) {
        this.$message.error('请先新增住院信息');
        return;
      }
      this.$refs.outpatInput.click();
    },
    async uploadImage(imgObjArr, type) {
      try {
        const res = await this.$apollo.mutate({
          mutation: gql`mutation(
          $hospitalization_id: Int!,
          $images: [HospitalizationImageInput!]!
        ){
          addHospitalizationImages(
            hospitalization_id: $hospitalization_id,
            images: $images
          ){
            id
            path
          }
        }`,
          variables: {
            hospitalization_id: this.addHospitalId,
            images: imgObjArr,
          },
        });
        this[type + 'Loading'] = false;
        return res.data.addHospitalizationImages;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
        this[type + 'Loading'] = false;
      }
    },
    async changeInpat(e) {
      this.inpatLoading = true;
      let imgObjArr = await this.selectImg(e, 1);
      // 上传
      if (imgObjArr) {
        if (this.addHospitalId > -1) {
          // 检测是否超过最大图片数量
          let totalImagesNum = this.inpatImagesList.length + (imgObjArr?imgObjArr.length:0);
          // console.log(this.inpatImagesList.length, imgObjArr?imgObjArr.length:0, totalImagesNum);
          if(totalImagesNum > this.maxImageNum){
            // console.log("超过图片最大数量限制!")
            this.$message.error('超过图片最大数量限制!');
            this.inpatLoading = false;
            return;
          }
          const inpatImagesList = await this.uploadImage(imgObjArr, 'inpat');
          if (inpatImagesList) {
            for (const item of inpatImagesList) {
              item.type = 1;
              item.deletePic = false;
              item.menuLeft = '';
              item.menuTop = '';
            }
            this.inpatImagesList = this.inpatImagesList.concat(inpatImagesList);
            this.allImagesList = this.allImagesList.concat(inpatImagesList);
            this.isRefreshHandler = true;
            this.isRefreshHandler1 = true;
          }
        } else {
          this.$message.error('请先新增住院信息');
          this.inpatLoading = false;
        }
      } else {
        this.inpatLoading = false;
      }
      e.target.value = '';
    },
    async changeOutpat(e) {
      this.outpatLoading = true;
      let imgObjArr = await this.selectImg(e, 2);
      // 上传
      if (imgObjArr) {
        if (this.addHospitalId > -1) {
          const outpatImagesList = await this.uploadImage(imgObjArr, 'outpat');
          if (outpatImagesList) {
            for (const item of outpatImagesList) {
              item.type = 2;
              item.deletePic = false;
              item.menuLeft = '';
              item.menuTop = '';
            }
            this.outpatImagesList = this.outpatImagesList.concat(outpatImagesList);
            this.allImagesList = this.allImagesList.concat(outpatImagesList);
            this.isRefreshHandler = true;
            this.isRefreshHandler1 = true;
          }
        } else {
          this.$message.error('请先新增住院信息');
          this.outpatLoading = false;
        }
      } else {
        this.outpatLoading = false;
      }
      e.target.value = '';
    },
    async selectImg(e, type) {
      // 如果没有选中文件就return
      if (!e.target.files.length) {
        return;
      }
      // const ext1 = e.target.files[0].name.match(/\.jpg$|\.jpeg$|\.png/);
      const imgObjArr = [];
      for (const item of e.target.files) {
        // let filesName = e.target.files[0];
        let reader = new FileReader();
        // 其他后缀的图片文件不接受
        let matchResult = item.name.match(/jpg$|jpeg$|JPG$|JPEG$|png$|PNG$|bmp$|BMP$|dib$/);
        // console.log("In selectImg, matchResult：",matchResult)
        let ext = "";
        if(matchResult){
          ext = matchResult[0];
        }else{
          continue;
        }

        const imgObj = {};
        await new Promise((resolve, reject) => {
          // const ext = [0];
          imgObj.type = type;
          reader.readAsDataURL(item);
          reader.onload = async event => {
            // imgData = event.target.result;
            if (ext === 'bmp' || ext === 'BMP' || ext === 'dib') {
              const base64 = await this.dealBmpImage(event.target.result);
              imgObj.base64 = base64.replace(/^data:image\/(jpeg|png);base64,/, "");
              imgObj.ext = 'jpg';
            } else {
              imgObj.base64 = event.target.result.replace(/^data:image\/(jpeg|png);base64,/, "");
              imgObj.ext = ext;
            }
            resolve();
          };
        });
        imgObjArr.push(imgObj);
      }
      return imgObjArr;
      //   await this.saveHospitalLogo(imgObjArr, ext, imgData);
    }
  },
  async created() {
    await this.getKnowledgeDic();
    await this.queryMyTemplate();
  },
};
</script>
<style lang="less">
.inHospitalDialog {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .dialog-pic .el-dialog__header{
    padding-bottom: 28px;
  }
  .el-dialog__wrapper{
    display: block;
  }
}
</style>
<style lang="less" scoped>
.inHospitalDialog {
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .dialog {
    min-width: 1205px;
    display: flex;
    align-items: center;
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
    }
  }
  .main {
    width: 100%;
    display: flex;
    padding: 0 16px;
    box-sizing: border-box;
    justify-content: space-between;
    .left {
      width: 650px;
      display: inline-block;
      .popInput {
        width: 294px;
        border: 1px solid #c0c0c0 !important;
        border-radius: 8px;
        height: 48px;
        box-sizing: border-box;
      }
      .popInputSingle {
        width: 619px !important;
      }
      .leftItemSubmit {
        width: 298px;
        height: 42px;
        margin-top: 34px;
      }
      .isBW {
        display: flex;

        .isBWItem {
          flex: 1;
          font-size: 20px !important;
          font-weight: 600;
        }
        .activeBW {
          background: white;
          color: black;
        }
      }
    }
    .right {
      display: inline-block;
      .rightItem {
        .rightItemContent {
          position: relative;
          border: 10px solid white;
          width: 475px;
          height: 333px;
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .images-wrap{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background-color: rgb(235,235,235);
            padding: 10px 5px 10px 20px;
            overflow-y: auto;
            .images-list{
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              .image-item{
                position: relative;
                width: 135px;
                height: 135px;
                margin-right: 4px;
                margin-bottom: 8px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
              }
              .image-item:nth-child(3n){
                margin-right: 0;
              }
            }
            .add-btn{
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              width: 414px;
              height: 60px;
              border: 3px dashed #fff;
              box-sizing: border-box;
              font-size: 22px;
              cursor: pointer;
            }
          }
          .rightItemIcon {
            font-size: 165px;
            color: white;
          }
        }
      }
      .inpatInput,
      .outpatInput {
        display: none;
      }
    }
  }
}
.icon-wrapper{
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 3px;
  margin-left: 3px;
  .menu-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33px;
    height: 30px;
    background-color: #ebebeb;
    border-radius: 5px;
    background-color: rgba(240, 240, 240, 0.9);
    cursor: pointer;
    user-select: none;
    .screen-icon {
      color: #1296db;
      font-size: 22px;
    }
    .delete-icon {
      width: 28px;
      height: 26px;
    }
    .love-icon {
      width: 28px;
      height: 28px;
    }
    .ai-text{
      color: rgb(64, 165, 219);
      font-size: 24px;
    }
  }
  .menu-btn + .menu-btn {
    margin-left: 2px;
  }
  .menu-btn:hover{
    background-color: #ccc;
  }
}
</style>
